import { themeDark, themePrimary } from 'shared/utils/cssUtility';
import { SvgIconType } from './svg.interface';

const LogoHeader: SvgIconType = ({
  width = 30,
  height = 30,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 111 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.0006 23.9658C37.208 20.6294 37.0006 17.1937 37.7081 13.9813C39.7702 4.72865 48.8357 -1.2248 58.1083 0.213953C67.8081 1.72713 74.3114 9.78911 73.7988 19.6991C73.2863 29.6712 65.9901 37.1503 56.327 37.4728C52.1054 37.6092 47.8837 37.4728 43.6624 37.5098C38.367 37.5596 36.8296 39.1098 36.7321 44.4061C36.6468 49.3671 36.8907 54.3533 36.3538 59.2649C35.2558 69.3734 26.6785 76.1205 16.5882 75.2647C6.498 74.4089 -0.249168 66.347 0.00705302 55.4695C0.238873 45.8198 7.8767 38.192 17.6497 37.9441C21.8713 37.8324 26.0928 37.9441 30.3145 37.9068C35.3411 37.8573 37.1226 36.0092 37.1958 30.8247C37.2323 28.5426 37.1958 26.2603 37.1958 23.9906H37.0006V23.9658Z"
      fill="#5456AD"
    />
    <path
      d="M74.3846 61.8324C74.3846 60.0834 74.3724 58.3471 74.3846 56.5984C74.5188 45.6091 82.2419 37.82 92.9058 37.9193C103.289 38.0186 111.036 46.0556 111 56.6974C110.963 67.3268 103.325 75.1408 92.7594 75.2896C88.8062 75.3516 84.8408 75.2896 80.8876 75.3145C75.4461 75.3516 73.9331 76.9145 73.8477 82.5704C73.7746 87.2587 73.9941 91.9719 73.6036 96.6353C72.8351 105.714 65.8195 112.499 56.9981 113.119C47.7984 113.764 39.8922 108.121 37.6595 99.3143C34.5969 87.2213 42.9181 76.0091 55.2166 75.7236C59.4383 75.6246 63.6599 75.7485 67.8813 75.699C72.4689 75.6371 74.2504 73.8012 74.3724 69.0509C74.4335 66.6322 74.3724 64.2262 74.3724 61.8075L74.3846 61.8324Z"
      fill="#D8B8F3"
    />
  </svg>
);
export default LogoHeader;
